import { useCallback, useEffect } from "react";
import { ZoomMtg } from "@zoom/meetingsdk";
import { playerConfig } from "../../types/playerConfig";

type Props = {
  config: playerConfig;
};

declare global {
  interface Window {
    onBackPressed: () => void;
  }
}

export default function Player({ config }: Props) {
  const showMeetingContainer = useCallback(() => {
    const zoomContainerElement = document.getElementById("zmmtg-root");
    if (zoomContainerElement) {
      zoomContainerElement.style.display = "block";
    }
  }, []);

  const initialMeeting = useCallback(() => {
    let {
      meeting_number: meetingNumber,
      user_name: userName,
      zak,
      email: userEmail,
      tk,
      signature,
      sdkKey,
      leaveUrl,
    } = config;

    ZoomMtg.init({
      leaveUrl,
      disableInvite: true,
      debug: false,
      disableCORP: !window.crossOriginIsolated,
      meetingInfo: ["host", "topic"],
      success: () => {
        ZoomMtg.join({
          signature,
          meetingNumber,
          userName,
          passWord: "",
          userEmail,
          sdkKey,
          ...(zak ? { zak } : undefined),
          ...(tk ? { tk } : undefined),
          success: (success: any) => {
            // console.log(success)
          },
          error: (error: any) => {
            // console.log(error)
          },
        });
      },
      error: (err: any) => {
        window.location.href = leaveUrl;
      },
    });
  }, [config]);

  useEffect(() => {
    if (Object.keys(config).length) {
      let { signature } = config;
      showMeetingContainer();
      ZoomMtg.setZoomJSLib("https://source.zoom.us/5.1.4/lib", "/av");
      ZoomMtg.prepareWebSDK();
      ZoomMtg.preLoadWasm();
      ZoomMtg.i18n.load("en-US");
      ZoomMtg.i18n.reload("en-US");
      if (signature) {
        initialMeeting();
      }

      if (window) {
        window.onBackPressed = () => {
          ZoomMtg.leaveMeeting({});
        };
      }

      window.addEventListener("unload", () => {
        ZoomMtg.leaveMeeting({});
        //@ts-ignore
        if (window && window?.JSBridge) {
          //@ts-ignore
          window?.JSBridge?.onZoomMeetingClose();
        }
        // for ios webview
        else if (
          window &&
          (window as any)?.webkit?.messageHandlers?.onZoomMeetingClose
            ?.postMessage
        ) {
          (
            window as any
          )?.webkit?.messageHandlers?.onZoomMeetingClose?.postMessage?.();
        }
      });
    }
  }, [config, initialMeeting, showMeetingContainer]);
  return <></>;
}
